/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Language_RequiredInputs */



/**
* | output |
* | --- |
* | "Content links need at least one language, so readers can filter for them." |
*
* @param {Community_Link_Language_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_language_required = /** @type {((inputs?: Community_Link_Language_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Language_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les liens de contenu doivent indiquer au moins une langue, pour que les lecteurs puissent les filtrer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los enlaces de contenido necesitan al menos un idioma, para que quien lee pueda filtrarlos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Links de conteúdo precisam de pelo menos um idioma, para que os leitores possam filtrá-los.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I link di contenuto richiedono almeno una lingua, così i lettori possono filtrarli.")
	return /** @type {LocalizedString} */ ("Content links need at least one language, so readers can filter for them.")
});